import 'assets/styles/Calendar.css';

const FormHeader = () => {
  return (
    <div className="form-header"></div>
  );
};

export default FormHeader;